import React from 'react';
import PropTypes from 'prop-types';
import './Footer.scss';

const isExternal = (href) => /^https?:\/\//i.test(href);

const anchorProps = (href) =>
  isExternal(href) ? { target: '_blank', rel: 'noopener noreferrer' } : {};

const legalLinkClassName = (link) =>
  'site-footer__legal-link' + (link.className ? ` ${link.className}` : '');

const legalButtonClassName = (link) =>
  'site-footer__legal-link site-footer__legal-link--btn' + (link.className ? ` ${link.className}` : '');

/** Privacy choices icon (CCPA opt-out toggle) */
const PrivacyChoicesIcon = () => (
<svg className="site-footer__privacy-icon" xmlns="http://www.w3.org/2000/svg" width="39" height="18" viewBox="0 0 39 18" fill="none" aria-hidden="true" alt="Privacy features logo">
  <g clipPath="url(#clip0_4241_4234)">
    <path d="M29.117 0H9.57285C4.55824 0 0.572266 3.98597 0.572266 9.00058C0.572266 14.0152 4.55824 18.0012 9.57285 18.0012H29.117C34.1316 18.0012 38.1175 14.0152 38.1175 9.00058C38.1175 3.98597 34.003 0 29.117 0ZM18.3163 16.4582H9.57285C5.4583 16.4582 2.11522 13.1151 2.11522 9.00058C2.11522 4.88603 5.4583 1.54296 9.57285 1.54296H22.3022L18.3163 16.4582ZM31.8171 12.858C31.56 13.1151 31.0457 13.1151 30.7885 12.858L27.9598 10.0292L25.131 12.858C24.8738 13.1151 24.3595 13.1151 24.1024 12.858C23.8452 12.6008 23.8452 12.0865 24.1024 11.8293L26.8025 9.00058L23.9738 6.17183C23.7166 5.91467 23.7166 5.40035 23.9738 5.14319C24.2309 4.88603 24.7453 4.88603 25.0024 5.14319L27.8312 7.97194L30.6599 5.14319C30.9171 4.88603 31.4314 4.88603 31.6886 5.14319C31.9457 5.40035 31.9457 5.91467 31.6886 6.17183L28.9884 9.00058L31.8171 11.8293C32.0743 12.0865 32.0743 12.6008 31.8171 12.858Z" fill="white"/>
    <path d="M16.3872 5.27098C16.6443 5.52813 16.7729 6.04241 16.5157 6.29955L11.1157 12.5996C10.9872 12.7281 10.8586 12.8567 10.73 12.8567C10.4729 12.9853 10.0872 12.9853 9.83002 12.7281L7.00145 9.89955C6.74431 9.64241 6.74431 9.12813 7.00145 8.87098C7.25859 8.61384 7.77288 8.61384 8.03002 8.87098L10.3443 11.0567L15.23 5.27098C15.4872 5.01384 16.0015 5.01384 16.3872 5.27098Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_4241_4234">
      <rect width="38.69" height="18.0012" fill="white"/>
    </clipPath>
  </defs>
</svg>
);

/** Instagram icon */
const InstagramIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" alt="Instagram logo">
    <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2"/>
    <circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="2"/>
    <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor"/>
  </svg>
);

/** Facebook icon */
const FacebookIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="24" viewBox="0 0 14 24" fill="none" alt="Facebook logo">
    <path d="M3.06128 14.0297V24H8.44172V14.0297H12.4539L13.2887 9.44531H8.44172V7.82344C8.44172 5.4 9.38329 4.47188 11.8138 4.47188C12.5698 4.47188 13.1774 4.49062 13.5299 4.52812V0.370313C12.8667 0.1875 11.2433 0 10.3063 0C5.34797 0 3.06128 2.36719 3.06128 7.47187V9.44531H0V14.0297H3.06128Z" fill="white"/>
  </svg>
);

/** YouTube icon */
const YouTubeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="31" height="24" viewBox="0 0 31 24" fill="none" alt="YouTube logo">
    <path d="M29.3891 3.75625C29.0429 2.275 28.0262 1.1125 26.7348 0.71875C24.3938 0 15.0078 0 15.0078 0C15.0078 0 5.62173 0 3.28072 0.71875C1.98931 1.1125 0.972675 2.275 0.626468 3.75625C0 6.4375 0 12.025 0 12.025C0 12.025 0 17.6125 0.626468 20.2938C0.972675 21.775 1.98931 22.8875 3.28072 23.2812C5.62173 24 15.0078 24 15.0078 24C15.0078 24 24.3938 24 26.7348 23.2812C28.0262 22.8875 29.0429 21.7688 29.3891 20.2938C30.0155 17.6125 30.0155 12.025 30.0155 12.025C30.0155 12.025 30.0155 6.4375 29.3891 3.75625ZM11.9414 17.1V6.95L19.7832 12.025L11.9414 17.1Z" fill="white"/>
  </svg>
);

/** Reddit icon */
const RedditIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="30" viewBox="0 0 35 30" fill="none" alt="Reddit logo">
    <path d="M21.9497 4.39237C22.3289 5.96753 23.7723 7.14094 25.4959 7.14094C27.5081 7.14094 29.1393 5.54235 29.1393 3.57047C29.1393 1.59859 27.5081 0 25.4959 0C23.7365 0 22.2692 1.22196 21.9275 2.84734C18.981 3.15701 16.6801 5.60596 16.6801 8.57382C16.6801 8.58051 16.6801 8.58554 16.6801 8.59223C13.4756 8.72447 10.5495 9.61835 8.22645 11.0295C7.36384 10.375 6.28087 9.98493 5.10566 9.98493C2.28551 9.98493 0 12.2246 0 14.9883C0 16.9936 1.20254 18.7211 2.93973 19.5196C3.10883 25.3281 9.56735 30 17.512 30C25.4566 30 31.9236 25.3231 32.0842 19.5095C33.8077 18.7061 35 16.9836 35 14.99C35 12.2263 32.7145 9.98661 29.8943 9.98661C28.7243 9.98661 27.6464 10.3733 26.7855 11.0228C24.4419 9.60161 21.4834 8.70773 18.2465 8.58889C18.2465 8.58386 18.2465 8.58052 18.2465 8.57549C18.2465 6.44962 19.859 4.6853 21.9497 4.39572V4.39237ZM8.02147 18.1637C8.10688 16.3492 9.33675 14.9565 10.7665 14.9565C12.1962 14.9565 13.2894 16.4279 13.204 18.2424C13.1186 20.0569 12.051 20.7164 10.6196 20.7164C9.18814 20.7164 7.93607 19.9782 8.02147 18.1637ZM24.2591 14.9565C25.6906 14.9565 26.9204 16.3492 27.0041 18.1637C27.0896 19.9782 25.8358 20.7164 24.4061 20.7164C22.9763 20.7164 21.907 20.0586 21.8216 18.2424C21.7362 16.4279 22.8277 14.9565 24.2591 14.9565ZM22.5578 22.3619C22.826 22.3887 22.9968 22.6615 22.8926 22.9059C22.0129 24.9665 19.9358 26.4145 17.512 26.4145C15.0881 26.4145 13.0127 24.9665 12.1313 22.9059C12.0271 22.6615 12.1979 22.3887 12.4661 22.3619C14.0376 22.2062 15.7372 22.1209 17.512 22.1209C19.2867 22.1209 20.9846 22.2062 22.5578 22.3619Z" fill="white"/>
  </svg>
);

const socialIconMap = {
  instagram: InstagramIcon,
  facebook: FacebookIcon,
  youtube: YouTubeIcon,
  reddit: RedditIcon,
};

export const Footer = ({
  legalLinks = [],
  socialLinks = [],
  hashtag = '#MoreToParkinsons',
  sponsoredText = 'Sponsored by Acadia Pharmaceuticals Inc.',
  disclosureText = 'Ryan Reynolds is a paid spokesperson for Acadia Pharmaceuticals. Michael Land is an Acadia employee. All participants were compensated for their time.',
  participants = [
    'Allie Signorelli',
    'Michael Land',
    'Dr. Salima Brillman',
    'Connie Carpenter-Phinney',
    'Dr. Yasar Torres-Yaghi',
  ],
  disclaimerText = 'Acadia does not provide medical advice or diagnoses\u2014information is provided for educational purposes only. Talk to your doctor if you have any questions about your medical condition.',
  copyrightText = '\u00A92026 Acadia Pharmaceuticals Inc. Acadia is a registered trademark of Acadia Pharmaceuticals Inc. All rights reserved. PDP-0531-v21 06/26.',
  logoSrc = '/images/acadia-logo.png',
  logoAlt = 'Acadia healthcare logo',
}) => {
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__inner container">
        {/* Left column */}
        <div className="site-footer__left">
          <p className="site-footer__us-residents">
            This website is intended for use by US residents.
          </p>

          <nav className="site-footer__legal" aria-label="Legal links">
            <ul className="site-footer__legal-list">
              {legalLinks.map((link, idx) => (
                <li key={link.href} className="site-footer__legal-item">
                  {link.href ? (
                    <a
                      href={link.href}
                      className={`gtm-link-external gtm-footer ${legalLinkClassName(link)}`}
                      {...(link.id && { id: link.id })}
                      {...anchorProps(link.href)}
                      {...(link.onClick && { onClick: link.onClick })}
                    >
                      {link.icon === 'privacy' && <PrivacyChoicesIcon />}
                      {link.label}
                    </a>
                  ) : (
                    <button
                      type="button"
                      className={legalButtonClassName(link)}
                      {...(link.id && { id: link.id })}
                      onClick={link.onClick}
                    >
                      {link.icon === 'privacy' && <PrivacyChoicesIcon />}
                      {link.label}
                    </button>
                  )}
                  {idx < legalLinks.length - 1 && (
                    <span className="site-footer__separator" aria-hidden="true">|</span>
                  )}
                </li>
              ))}
            </ul>
          </nav>

          <p className="site-footer__sponsored">{sponsoredText}</p>
          <div className="site-footer__disclosure">{disclosureText}
            <div className="site-footer__participants">
              {participants.map((name) => (
                <p key={name} className="site-footer__participant">{name}</p>
              ))}
            </div>
          </div>


          <p className="site-footer__disclaimer">{disclaimerText}</p>
          <p className="site-footer__copyright">{copyrightText}</p>
        </div>

        {/* Right column */}
        <div className="site-footer__right">
          <div className="site-footer__social-row">
            <span className="site-footer__hashtag">{hashtag}</span>
            <div className="site-footer__social">
              {socialLinks.map((link) => {
                const IconComponent = socialIconMap[link.icon] || null;
                return (
                  <a
                    key={link.href}
                    href={link.href}
                    className="site-footer__social-link js-interstitial gtm-footer gtm-link-external gtm-interstitial"
                    data-interstitial-type="social"
                    {...anchorProps(link.href)}
                    aria-label={link.label}
                  >
                    {IconComponent && <IconComponent />}
                  </a>
                );
              })}
            </div>
          </div>

          <div className="site-footer__brand">
            <a className="gtm-link-external gtm-footer" href="https://acadia.com/en-us" target="_blank" rel="noopener noreferrer">
              <img
                src={logoSrc}
                alt={logoAlt}
                className="site-footer__logo"
              />
            </a>
            <address className="site-footer__address">
              <p>Acadia Pharmaceuticals Inc.</p>
              <p>12830 El Camino Real, Suite 400</p>
              <p>San Diego, CA 92130</p>
            </address>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  legalLinks: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string,
      id: PropTypes.string,
      className: PropTypes.string,
      icon: PropTypes.string,
      onClick: PropTypes.func,
    })
  ),
  socialLinks: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      icon: PropTypes.oneOf(['instagram', 'facebook', 'youtube', 'reddit']),
    })
  ),
  hashtag: PropTypes.string,
  sponsoredText: PropTypes.string,
  disclosureText: PropTypes.string,
  participants: PropTypes.arrayOf(PropTypes.string),
  disclaimerText: PropTypes.string,
  copyrightText: PropTypes.string,
  logoSrc: PropTypes.string,
  logoAlt: PropTypes.string,
};

export default Footer;
